import React, { useState } from 'react';
import { Paper, Typography, Button, Box, FormControlLabel, Checkbox } from '@material-ui/core';
import desistir from '../../../../global/imagenes/desistir.png';
import { Grid, 
        TextField,
        Stepper,
        Step,
    StepLabel, } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import SignatureCanvas from 'react-signature-canvas';
import { FORM_DICTIONARY } from './schemas/formFields';

const CARD_STYLES = {
    card: {
        maxWidth: 320,
        width: '100%',
        minHeight: 200,
        cursor: 'pointer',
        borderRadius: 10,
        boxShadow: '0px 3px 8px rgba(0, 0, 0, 0.08)',
        transition: 'transform 0.12s ease, box-shadow 0.12s ease',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 24,
        padding: '12px 10px',
        background: '#fff',
        cursor: 'pointer',
        hover: { 
            boxShadow: '0px 8px 20px rgba(0, 0, 0, 0.12)', 
            transform: 'scale(1.02)', 
            maxWidth: 320,
        },
    },
    cardHeader: { fontSize: '0.95rem', fontWeight: 700, textAlign: 'center', color: '#111', marginBottom: 6 },
    cardImage: { width: 48, height: 48, objectFit: 'cover', display: 'block', margin: '0 auto 6px' },
    cardDescription: { fontSize: '0.85rem', lineHeight: '1.35', color: '#666', margin: '0px 8px', textAlign: 'justify', paddingLeft: 8, paddingRight: 8 },
    cardDescriptionAdvertencia: { fontSize: '0.85rem', lineHeight: '1.35', color: '#ec4b4bff', margin: '0px 8px', textAlign: 'justify', paddingLeft: 8, paddingRight: 8 },
};


export function FormularioDesistimientoBienestar({
    onSeleccionar,
    completada = false,
    disabled = false,
    modoLectura = false,
    modoAdministrador = false,
    mensajeDeshabilitado = '',
    mostrarMensajeDeshabilitado = false,
}) {
    const estaDeshabilitado = modoAdministrador ? (!completada || disabled) : (completada || disabled);
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', position: 'relative' }}>
            <Paper
                style={{
                    ...CARD_STYLES.card,
                    position: 'relative',
                    cursor: estaDeshabilitado ? 'not-allowed' : 'pointer',
                    opacity: estaDeshabilitado ? 0.6 : 1,
                    filter: estaDeshabilitado ? 'grayscale(60%)' : 'none',
                }}
                elevation={2}
                onClick={() => !estaDeshabilitado && onSeleccionar?.('disentimiento')}
            >
                {completada && (
                    <span style={{ position: 'absolute', top: 12, right: 12 }}>
                        <CheckCircleIcon style={{ color: 'rgb(90, 227, 94)', fontSize: 38 }} />
                    </span>
                )}
                <img src={desistir} alt="Desistir" style={{ width: 48, height: 48, marginBottom: 6, objectFit: 'contain' }} />
                <Typography style={CARD_STYLES.cardHeader}>DISENTIMIENTO INFORMADO</Typography>
                {estaDeshabilitado && mostrarMensajeDeshabilitado && (
                    <Typography style={{ ...CARD_STYLES.cardDescription, marginTop: 8 }}>
                        {mensajeDeshabilitado || 'Este formato aún no ha sido diligenciado por el estudiante.'}
                    </Typography>
                )}
            </Paper>
        </div>
    );
}


export function FormularioDisentimientoInformado({
    state,
    onChange,
    onError,
    servicio,
    firmaRefAcudiente,
    limpiarFirmaAcudiente,
    ProteccionDatosComponent,
    activeStep = 0,
}) {

    const steps = [
        'Protección de Datos Personales',
        'Información Personal',
        'Firma',
    ];

    const campos = FORM_DICTIONARY.general_disentimiento;

    const safeValue = (field) => {
        if (!state || !state[field]) return "";
        return typeof state[field].valor !== "undefined" ? state[field].valor : "";
    };

    const safeError = (field) => {
        if (!state || !state[field]) return "";
        return state[field].error || "";
    };


    const renderStep1 = () => (
        <Grid container spacing={3} style={{ marginTop: 10 }}>
            {ProteccionDatosComponent && (
                <Grid item xs={12}>
                    {ProteccionDatosComponent}
                </Grid>
            )}
        </Grid>
    );


    const renderStep2 = () => (
        <Grid container spacing={3} style={{ marginTop: 10 }}>

            <Grid item xs={12}>
                <TextField
                    disabled
                    fullWidth
                    required
                    label={campos.nombre.label}
                    name={campos.nombre.name}
                    value={safeValue('nombre_completo')}
                    onChange={onChange}
                    error={!!safeError('nombre_completo')}
                    helperText={safeError('nombre_completo')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    required
                    label={campos.documento.label}
                    name={campos.documento.name}
                    value={safeValue('documento')}
                    onChange={onChange}
                    error={!!safeError('documento')}
                    helperText={safeError('documento')}
                />
            </Grid>

            <Grid item xs={12} md={6}>
                <TextField
                    disabled
                    fullWidth
                    required
                    label={campos.servicio.label}
                    name={campos.servicio.name}
                    value={servicio?.nombre || ''}
                    InputProps={{ readOnly: true }}
                />
            </Grid>

            <Grid item xs={12}>
                <Paper style={{ padding: 16, backgroundColor:'#f9f9f9', borderLeft: '4px solid #c93030' }}>
                    <Typography variant="body2" style={{ whiteSpace: 'pre-line', lineHeight: 1.6, marginBottom: 16 }}>
                        {textoDisentimiento}
                    </Typography>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="disentimientoInformado"
                                checked={safeValue('disentimientoInformado') === "SI"}
                                error={!!safeError('disentimientoInformado')}
                                helperText={safeError('disentimientoInformado')}
                                onChange={(e) =>
                                    onChange({
                                        target: {
                                            name: 'disentimientoInformado',
                                            value: e.target.checked ? "SI" : ""
                                        }
                                    })
                                }
                            />
                        }
                        label="Declaro que entiendo la información anterior y acepto voluntariamente el desentimiento informado"
                    />
                </Paper>
            </Grid>
        </Grid>
    );


    const renderStep3 = () => (
        <Grid container spacing={3} style={{ marginTop: 10 }}>
                        <Grid item xs={12}>
                <Paper style={{ padding: 16, backgroundColor:'#f9f9f9', borderLeft: '4px solid #c93030' }}>
                    <Typography variant="body2" style={{ whiteSpace: 'pre-line', lineHeight: 1.6, marginBottom: 16 }}>
                        {textoDisentimientoInformado}
                    </Typography>
                </Paper>
            </Grid>
            <Grid item xs={12}>
                <Typography variant="subtitle2" align="center" gutterBottom style={{ fontWeight: 'bold' }}>
                    Firma
                </Typography>
                <Box
                    style={{
                        border: '2px solid #bbb',
                        backgroundColor: '#f9f9f9',
                        borderRadius: 4,
                    }}
                >
                    <SignatureCanvas
                        ref={firmaRefAcudiente}
                        penColor="black"
                        canvasProps={{ height: 200, style: { width: '100%', display: 'block' } }}
                    />
                </Box>
                {typeof limpiarFirmaAcudiente === 'function' && (
                    <Button
                        size="small"
                        variant="outlined"
                        color="secondary"
                        onClick={() => limpiarFirmaAcudiente(firmaRefAcudiente)}
                        style={{ marginTop: 8 }}
                    >
                        Limpiar firma
                    </Button>
                )}
            </Grid>
        </Grid>
    );


    const textoDisentimiento = `
        Declaro que he sido informado sobre los beneficios y el propósito del servicio, 
        y que he tenido la oportunidad de hacer preguntas y obtener respuestas satisfactorias. 
        Sin embargo, después de considerar cuidadosamente la información proporcionada, 
        decido voluntariamente desistir del servicio del cual fui remitido o había solicitado 
        de manera voluntaria.

        Entiendo que la decisión de no recibir el acompañamiento brindado por la universidad 
        es personal y que asumo la responsabilidad de mi bienestar emocional y psicológico. 
        Reconozco que la universidad ofrece este servicio como un recurso de apoyo y que mi 
        decisión no afectará mi calidad de estudiante. Al firmar este acuerdo, libero a la 
        Universidad de la Costa - CUC y a sus representantes de cualquier responsabilidad 
        relacionada con mi decisión de no recibir los servicios mencionados.
    `;

    const textoDisentimientoInformado = `
        El presente disentimiento informado deberá ser firmado en un plazo máximo de 72 (setenta y dos) horas a partir de su recepción. En caso de no recibir respuesta dentro del plazo establecido, se entenderá por parte de la institución que:
    
        1. El usuario no desea continuar con el servicio ofrecido.
        2. El presente documento se hace válido automáticamente.
    `;

    return (
        <>
            <Stepper activeStep={activeStep} alternativeLabel style={{ marginBottom: 16 }}>
                {steps.map((label) => (
                    <Step key={label}>
                        <StepLabel>{label}</StepLabel>
                    </Step>
                ))}
            </Stepper>

            {activeStep === 0 && renderStep1()}
            {activeStep === 1 && renderStep2()}
            {activeStep === 2 && renderStep3()}
        </>
    );
}

